/**
 * Predetermined Iglu wire values for catalog items (`type`, `format`).
 * Expand when Iglu admin exposes new enum values — unknown legacy strings still
 * display as raw text in SearchableSelect / detail.
 *
 * Note: multi codec / file-type lists use Iglu `formats` (array); this scalar
 * `format` is usually product presentation (see fixture: audiobook + type audioFile).
 */
export const ITEM_TYPE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'audioFile', label: 'Audio file' },
  { value: 'ebook', label: 'Ebook' },
  { value: 'podcast', label: 'Podcast' },
  { value: 'videoFile', label: 'Video file' },
  { value: 'bundle', label: 'Bundle / multi-part' },
  { value: 'periodical', label: 'Periodical / serial' },
  { value: 'graphicAudio', label: 'Graphic audio' },
  { value: 'music', label: 'Music' },
];

/** Includes empty string so users can clear format (sentinel handled server-side). */
export const ITEM_FORMAT_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '', label: '— None —' },
  { value: 'audiobook', label: 'Audiobook' },
  { value: 'ebook', label: 'Ebook' },
  { value: 'podcast', label: 'Podcast' },
  { value: 'audioDrama', label: 'Audio drama / full cast' },
  { value: 'dramatization', label: 'Dramatization' },
  { value: 'lecture', label: 'Lecture / spoken word' },
  { value: 'digital', label: 'Digital (generic)' },
  // Legacy / codec strings sometimes stored in `format` — keep selectable to normalize rows
  { value: 'mp3', label: 'MP3 (legacy codec)' },
  { value: 'm4b', label: 'M4B / AAC (legacy codec)' },
  { value: 'aac', label: 'AAC (legacy codec)' },
];

export function labelForItemType(value: string | undefined | null): string | undefined {
  if (value == null || value === '') return undefined;
  return ITEM_TYPE_OPTIONS.find((o) => o.value === value)?.label ?? value;
}

export function labelForItemFormat(value: string | undefined | null): string | undefined {
  if (value == null || value === '') return undefined;
  return ITEM_FORMAT_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
